import { ChartListResponse } from '../../../../models/chart';
import { AdminManageClerkChartFile } from './admin-manage-clerk-chart-file';

export type AdminManageClerkChartsProps = {
	charts: ChartListResponse[];
}
export const AdminManageClerkCharts = (props: AdminManageClerkChartsProps) => {

	return (
		<div className='grid w-full grid-cols-2 mb-14 gap-y-10 gap-x-4'>
			{props.charts.map((chart, index) => {
				return (
					<div className='w-full' key={index}>
						<AdminManageClerkChartFile chart={chart} />
					</div>
				)
			})}
		</div>
	)
}
